import { useQuery } from "@tanstack/react-query";
import { fetchDashboard } from "../services/dashboardService";

const DASHBOARD_QK = ["dashboard"];

export const useDashboard = (options = {}) =>
  useQuery({
    queryKey: DASHBOARD_QK,
    queryFn: fetchDashboard,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    ...options,
  });
